import { GenericError } from "@/assets/illustrations";
import { ErrorScreenProps } from "@/components/error-screen/types";
import {
  PAGE_NOT_FOUND_ERROR_TITLE,
  PAGE_NOT_FOUND_ERROR_SUBTITLE,
  PAGE_NOT_FOUND_ERROR_BUTTON_TEXT,
} from "./constants";

export const PAGE_NOT_FOUND_ERROR: ErrorScreenProps = {
  icon: <GenericError />,
  title: PAGE_NOT_FOUND_ERROR_TITLE,
  subtitle: PAGE_NOT_FOUND_ERROR_SUBTITLE,
  buttonText: PAGE_NOT_FOUND_ERROR_BUTTON_TEXT,
};
